import React from 'react';
import {Card, CardBody, Image} from '@nextui-org/react';

const HorizontalCard = ({heading, title, icon, alt, reverse = false}) => {
    return (
        <Card radius="md" className="bg-ubiBackgroundLight">
            <CardBody
                className={`flex flex-col md:flex-row ${
                    reverse ? "md:flex-row-reverse" : ""
                } gap-4 md:gap-6 lg:gap-8 p-4`}
            >
                {/* Image */}
                <div className="md:w-1/2">
                    <Image
                        removeWrapper
                        alt={alt}
                        className="z-0 w-full h-auto object-cover max-h-96"
                        src={icon}
                    />
                </div>

                {/* Text */}
                <div className="md:w-1/2 flex flex-col justify-center space-y-4">
                    <p className="text-large
                    text-base       /* Standard (Mobile) */
                    sm:text-base     /* ab sm-Breakpoint (640px) */
                    md:text-base      /* ab md-Breakpoint (768px) */
                    lg:text-xl     /* ab lg-Breakpoint (1024px) */
                    xl:text-xl     /* ab xl-Breakpoint (1280px) */
                    font-bold text-white">{heading}</p>
                    <p
                        className="
                        text-base       /* Standard (Mobile) */
                        sm:text-base     /* ab sm-Breakpoint (640px) */
                        md:text-base      /* ab md-Breakpoint (768px) */
                        lg:text-large     /* ab lg-Breakpoint (1024px) */
                        xl:text-large     /* ab xl-Breakpoint (1280px) */

                        text-white
                        leading-relaxed /* Lesefreundliche Zeilenhöhe */
                      "
                    >
                        {title}
                    </p>
                    {/*<CardFooter className="mt-4">*/}
                    {/*    <Button color="primary">Go to product</Button>*/}
                    {/*</CardFooter>*/}
                </div>
            </CardBody>
        </Card>
    );
};

export default HorizontalCard;
